export default "__VITE_ASSET__D63sF8u4__"